import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReportStore } from '@/store/report'

export function useComsuptionChart(sensorData: any[] = [], sensorCompareData: any[] = []) {
  const { t } = useI18n()
  const reportStore = useReportStore()

  const baseData = sensorData?.map((sensor) => sensor.totalConsumption) || []
  const compareData = sensorCompareData?.map((sensor) => sensor.totalConsumption) || []

  const series = ref([
    {
      name: 'Período Base',
      data: baseData,
    },
    {
      name: 'Período Comparação',
      data: compareData,
    },
  ])

  const categories = ref(sensorData?.map((sensor) => sensor.sensorName) || [])

  const chartOptions = ref({
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
        tools: {
          download: false,
        },
      },
    },
    colors: [reportStore.getBaseChartColors, reportStore.getCompareChartColors],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'center',
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(0)} kWh`,
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: ['#fff'],
      },
      background: {
        enabled: true,
        foreColor: '#000',
        padding: 6,
        borderColor: '#000',
        borderWidth: 1,
        opacity: 1,
      },
    },
    legend: {
      show: true,
      fontSize: '14px',
      fontWeight: 'regular',
      labels: {
        colors: ['#000'],
        useSeriesColors: true,
      },
      position: 'bottom',
      offsetY: 10,
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val: number) => `${val?.toFixed(0)} kWh`,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'regular',
          colors: ['#000'],
        },
      },
    },
    xaxis: {
      categories: categories.value,
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'regular',
          colors: ['#000'],
        },
      },
    },
  })

  watch(
    () => [reportStore.getBaseChartColors, reportStore.getCompareChartColors],
    ([baseColor, compareColor]) => {
      chartOptions.value = {
        ...chartOptions.value,
        colors: [baseColor, compareColor],
      }
    },
    { immediate: true, deep: true },
  )

  watch(
    () => reportStore.getEnergySensorConsumption,
    (newSensorConsumption) => {
      if (newSensorConsumption?.length) {
        series.value[0].data = newSensorConsumption.map((sensor) => sensor.totalConsumption)
        categories.value = newSensorConsumption.map((sensor) => sensor.sensorName)
        chartOptions.value = {
          ...chartOptions.value,
          xaxis: {
            ...chartOptions.value.xaxis,
            categories: categories.value,
          },
        }
      }
    },
    { immediate: true, deep: true },
  )

  watch(
    () => reportStore.getCompareEnergySensorConsumption,
    (newSensorConsumption) => {
      if (newSensorConsumption?.length) {
        series.value[1].data = newSensorConsumption.map((sensor) => sensor.totalConsumption)
        if (categories.value.length === 0) {
          categories.value = newSensorConsumption.map((sensor) => sensor.sensorName)
          chartOptions.value = {
            ...chartOptions.value,
            xaxis: {
              ...chartOptions.value.xaxis,
              categories: categories.value,
            },
          }
        }
      } else {
        series.value[1].data = []
      }
    },
    { immediate: true, deep: true },
  )

  return { chartOptions, series }
}
